import { MessageType } from "../../../types/chat";

export const cryptLib = {
  key: "!abc",
  pos: 1,

  decrypt(str: string) {
    let encryptedStr = "";
    this.pos = 1;
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i) + this.key.charCodeAt(this.pos);
      encryptedStr += String.fromCharCode(charCode);
      this.pos++;
      if (this.pos > this.key.length - 1) this.pos = 1;
    }
    return encryptedStr;
  },

  encrypt(str: string) {
    let decryptedStr = "";
    this.pos = 1;
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i) - this.key.charCodeAt(this.pos);
      decryptedStr += String.fromCharCode(charCode);
      this.pos++;
      if (this.pos > this.key.length - 1) this.pos = 1;
    }
    return decryptedStr;
  },
};
